import { Component, ReactNode } from 'react'

import Checkbox from '../../libs/ui/inputs/Checkbox'

import { BasePrivacyType, BasePrivacyProps, BasePrivacyStatus } from './BasicPrivacy'


class NoMotorPrivacy extends Component<BasePrivacyProps, BasePrivacyStatus> {

    constructor (props: any) {
        super(props)

        this.state = {
            generale: this.props.basePrivacy.generale,
            newsletter: this.props.basePrivacy.newsletter,
            profilazione: false,  // this.props.basePrivacy.profilazione,
            commerciale: this.props.basePrivacy.commerciale,
            cessione: this.props.basePrivacy.cessione,
            cgu: this.props.basePrivacy.cgu,
            ivass: this.props.basePrivacy.ivass,
            allegato3e4ter: false // this.props.basePrivacy.allegato3e4ter,
        }

        this.updateIvass = this.updateIvass.bind(this)
        this.updateCgu = this.updateCgu.bind(this)
        this.updateGenerale = this.updateGenerale.bind(this)
        this.updateNewsletter = this.updateNewsletter.bind(this)
        this.updateProfilazione = this.updateProfilazione.bind(this)
        this.updateCessione = this.updateCessione.bind(this)
        this.updateCommerciale = this.updateCommerciale.bind(this)
    }

    render(): ReactNode {
        const errorIvas = ( this.props.error !== undefined && !this.props.basePrivacy.ivass ) ? 'Consenso obbligatorio' : undefined
        const errorCgu = ( this.props.error !== undefined && !this.props.basePrivacy.cgu ) ? 'Consenso obbligatorio' : undefined
        const errorGenerale = ( this.props.error !== undefined && !this.props.basePrivacy.generale ) ? 'Consenso obbligatorio' : undefined

        return (
            <>
                <p className='col-12 titleLev4 mt-3'>Informativa IVASS</p>

                <div className='col-12 form-group'>                    
                    <Checkbox
                        id={this.props.id + '_ivass'} key={this.props.id + '_ivass'}
                        checked={this.props.basePrivacy.ivass}
                        name='ivass'
                        callback={this.updateIvass}
                        error={errorIvas}
                    >
                        <>
                            <span>
                                Dichiaro di aver letto l'<a className="privacy-link underline" target="_blank" rel="noopener noreferrer" href="https://www.6sicuro.it/informativa-precontrattuale/">informativa precontrattuale</a> di 
                                cui alla normativa vigente ai sensi del d.lgs. 209/2005 (Codice delle Assicurazioni Private) e leggi e regolamenti collegati e di averne stampato o salvato copia. 
                                Clicca sul <a className="privacy-link underline" target="_blank" rel="noopener noreferrer" href="https://www.6sicuro.it/wp-content/uploads/2025/07/MUP_Allegato_3_Howden.pdf">link</a> per visualizzare l'allegato 3 "Modulo unico precontrattuale (MUP) 
                                per i contratti assicurativi". (campo obbligatorio)
                            </span>
                            <ul className='privacy-reference-ul'>
                                <li className='privacy-reference-li mt-1'>
                                    In ottemperanza all'art. 9 comma 4 del Reg. IVASS 23/2008, dichiaro altresì di avere stampato, letto, compreso ed archiviato su supporto duraturo la tabella contenente le informazioni sui livelli provvigionali percepiti dalle 
                                    compagnie assicurative con cui 6sicuro brand di Howden s.p.a. ha rapporti di affari nel ramo RCA.
                                </li>
                                <li className='privacy-reference-li mt-1'>
                                    In ottemperanza all'art. 34 del D.L. 1/2012 e dell'art. 6 del Documento di Consultazione 49/2012, dichiaro di aver preso visione delle note informative relative ai prodotti 
                                    assicurativi, già predisposte e pubblicate sui siti internet aziendali delle compagnie assicurative di cui il preventivatore di 6sicuro (brand di Howden s.p.a.) fornisce le 
                                    quotazioni e raggiungibili dalla pagina note informative.
                                </li>
                                <li className='privacy-reference-li mt-1'>
                                    In ottemperanza all'art.61 del Reg. IVASS 40/2018, dichiaro di voler ricevere tramite l’email comunicata in fase di accesso la documentazione precontrattuale, i preventivi 
                                    e la documentazione contrattuale, nonché ogni altra comunicazione proveniente da Howden s.p.a., con riferimento ai contratti in corso e a quelli futuri. Sono consapevole della  
                                    possibilità di modificare la mia scelta in qualsiasi momento, Condizioni generali del servizio.
                                </li>
                            </ul>
                        </>
                    </Checkbox>
                </div>

                {this.props.isLogged !== true &&
                    <>
                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_cgu'} key={this.props.id + '_cgu'}
                                checked={this.props.basePrivacy.cgu ?? false}
                                name='cgu'
                                callback={this.updateCgu}
                                error={errorCgu}
                            >
                                Accetto le condizioni generali del servizio di comparazione offerto da 6sicuro che dichiaro di aver letto e compreso al seguente&nbsp; 
                                <a className="privacy-link underline" href="https://www.6sicuro.it/condizioni-generali-di-utilizzo/" target="_blank">
                                    link
                                </a> (necessario per usufruire dei servizi offerti dal Sito).
                            </Checkbox>
                        </div>

                        <p className='col-12 titleLev4 mt-3'>Informativa privacy</p>

                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_generale'} key={this.props.id + '_generale'}
                                checked={this.props.basePrivacy.generale ?? false}
                                name='generale'
                                callback={this.updateGenerale}
                                error={errorGenerale}
                            >
                                Dichiaro di aver letto&nbsp;
                                <a className="privacy-link underline" href={
                                    this.props.linkAlternativePrivacy === true
                                        ? "https://www.6sicuro.it/informativa-privacy-infortuni-mutuo-vita/"   // "https://assicurativo.6sicuro.it/informativa-privacy-infortuni-mutuo-vita/"
                                        : "https://www.6sicuro.it/privacy/"
                                } 
                                target="blank">
                                    l’informativa sulla privacy
                                </a> redatta ai sensi del Regolamento (UE) 2016/679 ("GDPR") e specificatamente gli artt. 2.1.a, 2.1.b, 2.1.c, 2.1.d, 2.1.e, 2.1.f, 2.1.g. (campo obbligatorio) {/** , 2.1.h */}
                            </Checkbox>
                        </div>

                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_newsletter'} key={this.props.id + '_newsletter'}
                                checked={this.props.basePrivacy.newsletter ?? false}
                                name='newsletter'
                                callback={this.updateNewsletter}
                            >
                                Acconsento all’invio della newsletter (art. 2.1.e dell’informativa) (consenso facoltativo)
                            </Checkbox>
                        </div>

                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_commerciale'} key={this.props.id + '_commerciale'}
                                checked={this.props.basePrivacy.commerciale ?? false}
                                name='commerciale'
                                callback={this.updateCommerciale}
                            >
                                Acconsento al trattamento dei dati per le finalità di comunicazione e commerciali operate direttamente da Howden s.p.a. 
                                (art. 2.1.f dell’informativa) (consenso facoltativo)
                            </Checkbox>
                        </div>

                        {/*
                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_profilazione'} key={this.props.id + '_profilazione'}
                                checked={this.props.basePrivacy.profilazione ?? false}
                                name='profilazione'
                                callback={this.updateProfilazione}
                            >
                                Acconsento al trattamento dei dati per le attività di profilazione (art. 2.1.g dell’informativa) (consenso facoltativo)
                            </Checkbox>
                        </div>
                        */}

                        <div className='col-12 form-group'>
                            <Checkbox
                                id={this.props.id + '_cessione'} key={this.props.id + '_cessione'}
                                checked={this.props.basePrivacy.cessione ?? false}
                                name='cessione'
                                callback={this.updateCessione}
                            >
                                <span>
                                    Acconsento al trattamento dei dati per le finalità di comunicazione, cessione o concessione in uso di dati a terze parti per finalità 
                                    proprie di queste ultime, per le seguenti categorie (art. 2.1.g dell’informativa) (consenso facoltativo):  {/* 2.1.h */}
                                </span>
                                <ul className='privacy-reference-ul'>
                                    <li className='privacy-reference-li mt-1'>
                                        Bancario, finanziario, assicurativo
                                    </li>
                                    <li className='privacy-reference-li mt-1'>
                                        Automotive
                                    </li>
                                    <li className='privacy-reference-li mt-1'>
                                        Beni di largo consumo
                                    </li>
                                    <li className='privacy-reference-li mt-1'>
                                        Telecomunicazioni, telefonia, informatica
                                    </li>
                                    <li className='privacy-reference-li mt-1'>
                                        Servizi alla persona e tempo libero
                                    </li>
                                </ul>
                            </Checkbox>
                        </div>
                    </>
                }
            </>
        )
    }

    private updateProfilazione (val: boolean) {
        this.setState({
            profilazione: val
        }, () => {
            this.props.callback?.(
                this.getPrivacyFromState()
            )
        })
    }

    private updateCessione (val: boolean) {
        this.setState({
            cessione: val
        }, () => {
            this.props.callback?.(
                this.getPrivacyFromState()
            )
        })
    }

    private updateCommerciale (val: boolean) {
        this.setState({
            commerciale: val
        }, () => {
            this.props.callback?.(
                this.getPrivacyFromState()
            )
        })
    }

    private updateNewsletter (val: boolean) {
        this.setState({
            newsletter: val
        }, () => {
            this.props.callback?.(
                this.getPrivacyFromState()
            )
        })
    }
    
    private updateCgu (val: boolean) {
        this.setState({
            cgu: val,
        }, () => {
                this.props.callback?.(
                    this.getPrivacyFromState()
                )
            }
        )
    }

    private updateGenerale (val: boolean) {
        this.setState({
                generale: val
            }, () => {
                this.props.callback?.(
                    this.getPrivacyFromState()
                )
            }
        )
    }

    private updateIvass (val: boolean) {
        this.setState({
            ivass: val
        }, () => {
            this.props.callback?.(
                this.getPrivacyFromState()
            )
        })
    }

    private getPrivacyFromState () : BasePrivacyType {
        return (this.props.isLogged)
            ?   {
                    ivass: this.state.ivass,
                }
            :   {
                    generale: this.state.generale,
                    newsletter: this.state.newsletter,
                    profilazione: this.state.profilazione,
                    commerciale: this.state.commerciale,
                    cessione: this.state.cessione,
                    cgu: this.state.cgu,
                    ivass: this.state.ivass,
                    allegato3e4ter: false // this.state.allegato3e4ter,
                }
    }
}

export default NoMotorPrivacy